module.exports = __webpack_public_path__ + "media/images/bnr_referral_menu-afc6c39dc1ee0374d3efe2e1f51067d6.png";